import type {
  AnalyzeWebsiteRequest,
  OnboardingWebsiteAnalysis,
  ScrapeCarsByLinksRequest,
  ScrapeCarsByLinksResponse,
} from '../types/onboarding';
import baseApi from './baseApi';

export interface SetupOnboardingRequest {
  companyUrl: string;
}

export interface SetupOnboardingResponse {
  message: string;
  businessUnit: {
    id: number;
    name: string;
    companyUrl: string;
  };
}

export const setupOnboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateCompanyUrl: builder.mutation<SetupOnboardingResponse, SetupOnboardingRequest>({
      query: (data) => ({
        url: '/auth-protected/setup-onboarding',
        method: 'PUT',
        body: data,
      }),
    }),
    analyzeWebsite: builder.mutation<OnboardingWebsiteAnalysis, AnalyzeWebsiteRequest>({
      query: (data) => ({
        url: '/onboarding/analyze-website',
        method: 'POST',
        body: data,
      }),
    }),
    scrapeCars: builder.mutation<ScrapeCarsByLinksResponse, ScrapeCarsByLinksRequest>({
      query: (data) => ({
        url: '/onboarding/scrape-cars',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useUpdateCompanyUrlMutation, useAnalyzeWebsiteMutation, useScrapeCarsMutation } = setupOnboardingApi;
